import React from 'react'
import { useIntl } from 'react-intl'
import DownloadSSOMetadataButton from './DownloadSSOMetadataButton'
import Heading from '../Heading'

const SSOIntegrations = () => {
	const { formatMessage } = useIntl()

	return (
		<div>
			<Heading size="xl" className="mb-3">
				{formatMessage({ id: 'sso.sso_integrations' })}
			</Heading>
			<div className="flex flex-col sm:flex-row gap-10 items-start sm:gap-2 sm:items-center ml-2">
				<DownloadSSOMetadataButton
					ssoIntegration="TheBigPOS"
					text={formatMessage({
						id: 'sso.download_bpos_metadata_file',
					})}
					regenerateText={formatMessage({
						id: 'sso.regenerate_bpos_metadata_file',
					})}
				/>
				<DownloadSSOMetadataButton
					ssoIntegration="ConsumerConnect"
					text={formatMessage({
						id: 'sso.download_cc_metadata_file',
					})}
					regenerateText={formatMessage({
						id: 'sso.regenerate_cc_metadata_file',
					})}
				/>
			</div>
		</div>
	)
}

export default SSOIntegrations
